"use client";
import { useEffect } from "react";
import { PageMargin } from "@/components/common";
import Link from "next/link";
import { logException } from "@/analytics/sentry";
import { SentryFeatureTags } from "@punchup/sentry";
import ErrorImg from "@/components/common/ErrorImg";

export default function TopLevelErrorHandler({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logException(error, {
      extra: { digest: error.digest },
      tags: { feature: SentryFeatureTags.ErrorBoundary },
    });
  }, [error]);

  return (
    <>
      <PageMargin>
        <div className="mt-14 md:mt-32 lg:mt-40 flex flex-col lg:flex-row justify-center items-center mb-20 md:mb-28 lg:mb-32">
          <div>
            <ErrorImg className="h-20 sm:h-16 md:h-20 lg:h-auto" />
          </div>
          <h2 className="ml-5 text-4xl lg:text-5xl xl:text-6xl font-bold text-center">
            Oops, something <span className="inline-block">went wrong.</span>
          </h2>
        </div>

        <h4 className="mb-10 md:mb-20 text-center">
          Return to the{" "}
          <Link
            href="/"
            className="text-primary underline hover:brightness-125"
          >
            homepage
          </Link>{" "}
          or
          <button
            onClick={
              // Attempt to recover by trying to re-render the segment
              () => reset()
            }
            className="text-primary underline hover:brightness-125"
          >
            <span className="ml-1 underline">try again</span>
          </button>
          .
        </h4>
      </PageMargin>
    </>
  );
}
